import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import QuoteSlider from './QuoteSlider';

const GiftTestimonials = (): JSX.Element => {
  const t = useTranslations();

  return (
    <section className="bg-sandstone-100 py-32">
      <TypographyV3 align="center" className="mb-16" variant="h2" Element="h3">
        {t.rich('pdp_horizon_quote_slider_title', {
          i(chunks: ReactNode) {
            return <em className="font-serif italic">{chunks}</em>;
          },
        })}
      </TypographyV3>
      <QuoteSlider />
    </section>
  );
};

export default GiftTestimonials;
